<template>
  <div class="flex flex-col gap-4 py-5">
    <h2 class="text-title-large md:text-headline-large flex grow flex-row items-center gap-0.5">
      {{ $t('settings.personal') }} <BaseIcon>chevron_right</BaseIcon>
      {{ $t('settings.notifications.title') }}
    </h2>

    <p class="text-body-medium text-on-surface-variant max-w-2xl">
      {{ $t('settings.notifications.muteHint') }}
    </p>

    <template v-if="hasNotifications">
      <div class="flex flex-row flex-wrap items-center justify-end gap-1">
        <BaseTextButton
          color="text"
          size="XS"
          :disabled="allEnabled"
          @click="setAllEmailNotifications(true)"
        >
          {{ $t('common.selectAll') }}
        </BaseTextButton>
        <BaseTextButton
          color="text"
          size="XS"
          :disabled="allDisabled"
          @click="setAllEmailNotifications(false)"
        >
          {{ $t('common.deselectAll') }}
        </BaseTextButton>
      </div>

      <div class="flex flex-col gap-6">
        <div v-for="group in notificationGroups" :key="group.id" class="flex flex-col gap-2">
          <h3 class="text-title-medium text-on-surface-variant">{{ group.title }}</h3>
          <div class="flex flex-col gap-0.5">
            <BaseSwitchListItem
              v-for="item in group.items"
              :key="item.key"
              :model-value="item.enabled"
              :title="item.label"
              :supporting-text="item.description"
              class="bg-surface-container-low rounded-extra-small first:rounded-t-large last:rounded-b-large"
              @update:model-value="(value) => setEmailNotification(item.key, value)"
            />
          </div>
        </div>
      </div>
    </template>
    <p v-else class="text-body-medium text-on-surface-variant max-w-2xl">
      {{ $t('settings.notifications.emptyHint') }}
    </p>
  </div>
</template>
<script setup lang="ts">
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseSwitchListItem from '@/core/components/base/switch-list-item/BaseSwitchListItem.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useNotificationSettings } from '../composables/use-notification-settings'

  const {
    notificationGroups,
    hasNotifications,
    allEnabled,
    allDisabled,
    setEmailNotification,
    setAllEmailNotifications,
  } = useNotificationSettings()
</script>
